import React, { FunctionComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';
import { ButtonMargin, SelectionContainer } from './SelectionContainer';

interface IProps {
  isSoloWorkout: boolean | null;
  setSoloWorkout(isSolo: boolean): void;
  t(key: string): string;
}

export const InviteFriendsSelection: FunctionComponent<IProps> = ({ t, isSoloWorkout, setSoloWorkout }) => {
  return (
    <View style={styles.container}>
      <SelectionContainer
        title={t('yes')}
        isSelected={isSoloWorkout === false}
        style={{ marginRight: ButtonMargin }}
        onPress={() => setSoloWorkout(false)}
        icon={(
          <View style={styles.iconContainer}>
            <Icon
              name='ios-people-outline'
              size={50}
              color={isSoloWorkout === false ? Theme.WHITE : Theme.CHARCOAL}
              styles={{ marginHorizontal: 5 }}
            />
          </View>
        )}
      />
      <SelectionContainer
        title={t('no')}
        style={{ marginLeft: ButtonMargin }}
        isSelected={isSoloWorkout === true}
        onPress={() => setSoloWorkout(true)}
        icon={(
          <View style={styles.iconContainer}>
            <Icon
              name='ios-person-outline'
              size={50}
              color={isSoloWorkout === true ? Theme.WHITE : Theme.CHARCOAL}
              styles={{ marginHorizontal: 5 }}
            />
          </View>
        )}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  iconContainer: {
    width: 50,
    height: 50,
    alignItems: 'center',
  },
});
